module.exports = __webpack_public_path__ + "static/media/ic_sound.375039ed.png";